export default "__VITE_ASSET___JxNUj$D__"